import { Editor } from '@tiptap/core';
import { StrikethroughIcon } from 'lucide-react';
import React from 'react';

import { Button } from '@/ui/Button';
import { cn } from '@/utils';

interface StrikeMenuItemProps {
	editor: Editor | null;
}

const StrikeMenuItem = (props: StrikeMenuItemProps) => {
	const { editor } = props;

	if (!editor) {
		return null;
	}

	return (
		<Button
			onClick={() => editor.chain().focus().toggleStrike().run()}
			disabled={!editor.can().chain().focus().toggleItalic().run()}
			className={cn('w-6 h-6 text-brand-gray-2 [&>svg]:size-6 [&>svg]:reset p-0 [&>svg]:left-[0px]', {
				'text-brand-blue': editor.isActive('strike'),
			})}
			size="icon"
			icon="left"
			variant="tetriary"
		>
			<StrikethroughIcon size={16} />
		</Button>
	);
};

export { StrikeMenuItem };
